import { Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { takeUntil } from 'rxjs/operators';
import { NumberUtil } from 'app/shared/util/number-util';
import { SubscribedContainer } from 'app/shared/util/subscribed-container';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { NgIf } from '@angular/common';
import { TranslateDirective } from '../../../../directives/translate.directive';

@Component({
  selector: 'jhi-bary-input-price',
  templateUrl: './bary-input-price.component.html',
  styleUrls: ['./bary-input-price.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, MDBBootstrapModulesPro, NgIf, TranslateDirective],
})
export class BaryInputPriceComponent extends SubscribedContainer implements OnInit {
  @Input() id = '';
  @Input() label: string | undefined;
  @Input() name: string | undefined;
  @Input() counter = false;
  @Input() disabled = false;
  @Input() min = 0;
  @Input() max = 999999;
  @Input() placeholder = '';
  @Input() currency: 'EUR' = 'EUR';
  @Input() control = new FormControl();

  _control!: FormControl;

  ngOnInit(): void {
    this._control = new FormControl(NumberUtil.formatNumberToCurrencyString(this.control.value), {
      validators: this.control.validator,
      updateOn: 'blur',
    });
    if (this.control.hasValidator(Validators.required)) {
      this._control.addValidators(Validators.required);
    }
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
    this.control.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(newValue => {
      if (newValue != null) {
        if ('' + newValue !== '' + this._control.value) {
          this._control.setValue(NumberUtil.formatNumberToCurrencyString(newValue), { emitEvent: false });
        }
      } else {
        this._control.setValue(null, { emitEvent: false });
      }
    });
    this._control.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(newValue => this.control.setValue(NumberUtil.formatStringWithUnitToNumber(newValue)));
  }

  checkValue($event: KeyboardEvent): boolean {
    if (($event.key < '0' || $event.key > '9') && $event.key !== '.' && $event.key !== ',') {
      $event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  formatTextValue(): void {
    const number = NumberUtil.formatStringWithUnitToNumber(this._control.value);
    this._control.setValue(NumberUtil.formatNumberToCurrencyString(number), { emitEvent: false });
  }
}
